import { SearchActionTypes } from '@state/features/common.types';
import analytics from '@utils/analytics';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
const addMarkersToSuggested = (searched, suggested) => {
    let regEx = new RegExp(searched, 'ig');
    let replaceMask = `<mark>${searched}</mark>`;
    return suggested.toLowerCase().replaceAll(regEx, replaceMask);
};
const SearchSuggestionPhrases = (props) => {
    const dispatch = useDispatch();
    const { inputSearch, suggestionPhrases } = useSelector((state) => state.search);
    const [wrapperHeight, setWrapperHeight] = useState(0);
    const wrapperRef = useRef(null);
    useEffect(() => {
        var _a;
        if (props.forceClose || !suggestionPhrases || !suggestionPhrases.length) {
            setWrapperHeight(0);
        }
        else if (inputSearch.length >= props.minChars && (suggestionPhrases === null || suggestionPhrases === void 0 ? void 0 : suggestionPhrases.length) > 0) {
            setWrapperHeight((_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight);
        }
    }, [suggestionPhrases, props.forceClose, inputSearch]);
    return (React.createElement("div", { className: "search-as-you-type", style: { height: wrapperHeight } },
        React.createElement("ul", { ref: wrapperRef, className: "search-suggestions" }, inputSearch.length >= props.minChars &&
            suggestionPhrases
                .filter((el) => inputSearch.toLowerCase() != el.value.toLowerCase())
                .filter((el, i) => i < 4)
                .map((el, i) => (React.createElement("li", { key: i },
                React.createElement("button", { type: "button", onClick: () => {
                        analytics.suggestionSearch(el.value.toLowerCase());
                        dispatch({
                            type: SearchActionTypes.INPUT_SEARCH,
                            payload: el.value,
                        });
                        dispatch({
                            type: SearchActionTypes.FETCH_SEARCH,
                            payload: {
                                resultsType: 'REFINE',
                            },
                        });
                        props.setLocalLoading();
                        setWrapperHeight(0);
                    }, dangerouslySetInnerHTML: { __html: addMarkersToSuggested(inputSearch, el.value) } })))))));
};
export default SearchSuggestionPhrases;
